//import {$} from 'jquery'

// import Swiper JS
import Swiper, { EffectFade } from 'swiper';
// import Swiper styles

document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

(function ($) {
  if($('.video-sections-swiper').length > 0) {
    const swiper = new Swiper('.video-sections-swiper', {
      direction: 'horizontal',
      effect: "fade",
      fadeEffect: { crossFade: true },
      //loop: true,
      modules: [EffectFade],
      speed: 350,
      on: {
        init: function () {
          pauseVideos(0);
          playVideo(0);
        },
      },
    });

    let clicked = false;

    swiper.on('slideChange', function (e) {
      //console.log(swiper.realIndex -1)
      if(!clicked) {
        showVideoDescription(swiper.realIndex)
      }
      //console.log('changed')

      pauseVideos(swiper.realIndex);
      clicked = false;
    });

    // swiper.on('transitionEnd slideChangeTransitionEnd', function () {
    //   console.log('trasition ended')
    //   playVideo(swiper.realIndex);
    // });

    $('.video-sections-slider video').first(function(){
      let video = $(this).get(0);
      video.addEventListener('loadeddata', (e) => {     
        if (video.paused()) {
          //console.log('paused it was')
          swiper.slideTo(0);
        }
      });
    });

    $('.video-sections-slider video').each(function(){
      
      let video = $(this).get(0);
      $(this).addClass('loaded');
      video.addEventListener('loadeddata', (e) => {     
        if(video.readyState >= 3){
          $(this).addClass('loaded');
        }
      });

      video.onended = (event) => {
        video.currentTime = 0;
        //console.log(swiper.isEnd)
        if (!swiper.isEnd) {
          swiper.slideNext();
        } else {
          swiper.slideTo(0);
        }
        
      }
    });

    $('.video-sections-slider .pages a').click(function(){
      let eq = $(this).data('id') - 1;
      showVideoDescription(eq)
      clicked = true;
      swiper.slideTo(eq);
      return false;
    });

    function showVideoDescription(eq) {
      $('.video-sections-slider .video-descriptions').hide();
      $('.video-sections-slider .video-descriptions').eq(eq).show();
    }

    function pauseVideos(slide) {
      $('.video-sections-slider video').each(function(){
        let video = $(this).get(0);
        video.pause();
        video.currentTime = 0;
        playVideo(slide);
      });
    }

    function playVideo(slide) {
      //console.log(slide)
      $('.video-sections-slider .swiper-slide:eq('+ slide +') video:visible').get(0).play();
    }
  }

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/sliders/video-slider.js